// hubdevbackend00 api setting
// https://hubdevbackend00.azurewebsites.net/swagger/index.html

export const LOGIN = 'LOGIN'

export const LOGOUT = 'LOGOUT'

export const FAQ = 'FAQ'

export const AUTHLOGIN = 'AUTHLOGIN'

export const LOGINREDIRECT = 'LOGINREDIRECT'

export const GETINDUSTRYNESTLIST = 'GETINDUSTRYNESTLIST'

export const FRONTENDGETORDERS = 'FRONTENDGETORDERS'

export const GETLOOKUPCODE = 'GETLOOKUPCODE'

export const GETSERVICE = 'GETSERVICE'

export const GETSUBSCRIPTION = 'GETSUBSCRIPTION'

export const USERS_ERROR = 'USER_ERROR'

export const REGIS_CHECK = 'REGIS_CHECK'

export const GETACCOUNT = 'GETACCOUNT'

export const DESIGNATEADMIN = 'DESIGNATEADMIN'

export const CHANGEACCOUNTSTATUS = 'CHANGEACCOUNTSTATUS'

export const ADDACCOUNT = 'ADDACCOUNT'

export const UPDATEACCOUNT = 'UPDATEACCOUNT'

export const GETCONTACT = 'GETCONTACT'

export const CONTACT = 'CONTACT'

export const TOSUB = 'TOSUB'

export const COUNTRY = 'COUNTRY'

export const SENDLETTER = 'SENDLETTER'

export const LETTERTOKEN = 'LETTERTOKEN'

export const GETCATEGORYLIST = 'GETCATEGORYLIST'